import { ArcGISIdentityManager } from '@esri/arcgis-rest-request';
import { useFormikContext } from 'formik';
import { useEffect, useState } from 'react';
import { useSiteConfig } from '@innovyze/stylovyze';

import { addRouteNamespace } from '@Utils/actions';
import {
	CreateIntegrationParams,
	IntegrationType,
	ArcGisSettingsFormValues,
} from '../../../types/integration.types';

export default function useEsriLogin() {
	// hooks
	const formikProps = useFormikContext<ArcGisSettingsFormValues>();
	const { config } = useSiteConfig();

	// states
	const [token, setToken] = useState<CreateIntegrationParams | undefined>();
	const [tokenString, setTokenString] = useState('');

	const handleAuthToEsri = async () => {
		try {
			localStorage.setItem('initializingArcGisItegration', 'true');
			const { origin } = window.location;
			const response = await ArcGISIdentityManager.beginOAuth2({
				clientId: config?.esri?.clientId || '',
				redirectUri: origin + addRouteNamespace('oauth/esri'),
				popup: true,
				pkce: true,
				expiration:
					Number(config?.esri?.refreshTokenExpiresIn) ||
					60 * 24 * 365,
			});
			setTokenString(JSON.stringify(response));
		} catch (e) {
			localStorage.removeItem('initializingArcGisItegration');
			console.log('exception: ' + e);
		}
	};

	useEffect(() => {
		if (tokenString) {
			const token = JSON.parse(tokenString);
			setToken(token);
		}
	}, [tokenString]);

	useEffect(() => {
		if (token) {
			formikProps.setValues(prevProps => ({
				...prevProps,
				integrationInfo: {
					...(prevProps.integrationInfo || {}),
					integrationType: IntegrationType.ArcGis,
					lastUpdatedData: new Date().toISOString(),
					username: token.username,
					authenticated: true,
					isValid: true,
				},
				integrationTokenInfo: token,
				token: token.token,
				clientId: token.clientId,
				refreshToken: token.refreshToken,
				refreshTokenExpires: token.refreshTokenExpires,
				portal: token.portal,
				ssl: token.ssl,
			}));
		}
	}, [token]);

	return { handleAuthToEsri };
}
